import React from "react"
import { Icon } from "../icon"
import type { IconName } from "../icon/assets/icon-map"
import { useNavigationContext } from "./navigation-context"

export type NavigationBadgeType = "paid" | "beta"

export const BADGE_ICONS: Record<NavigationBadgeType, IconName> = {
  paid: "diamond",
  beta: "beta-beaker"
}

/**
 * Inline badge icon rendered inside `Navigation.Item`, `Navigation.Group`,
 * and `Navigation.GroupItem` when a `badge` prop is set. Maps the semantic
 * type to the corresponding icon. Internal — used only via the `badge`
 * prop on the three navigation row primitives.
 *
 * Paid accounts (via `Navigation`'s `accountType` prop) suppress the
 * `"paid"` icon; beta icons always render. The tooltip callout, composed
 * separately in `NavigationLink`, is unaffected.
 */
export function NavigationBadge({ type }: { type: NavigationBadgeType }) {
  const { accountType } = useNavigationContext()

  if (type === "paid" && accountType === "paid") return null

  return (
    <Icon
      name={BADGE_ICONS[type]}
      // eslint-disable-next-line rulesdir/no-deprecated-icon-size
      size="sm"
      className="shrink-0 text-gray-700"
      aria-hidden
    />
  )
}
